<script lang="ts" setup>
import { ref, watch } from 'vue';
import { useRoute } from 'vue-router';

const rootEl = ref<HTMLElement | null>(null);
const route = useRoute();

watch(
  () => route.path,
  () => {
    rootEl.value?.scrollTo(0, 0);
  },
);
</script>

<template>
  <div
    ref="rootEl"
    class="affiliates"
  >
    <div class="content-wrapper">
      <RouterView />
    </div>
  </div>
</template>
